import type { PersonalizedTaskStatus, PersonalizedTasksStatus } from '@change-corgi/middle-end-gql-schema';

export const PERSONALIZED_TASK_STATUSES = {
	ACTIVE: 'ACTIVE',
	COMPLETED: 'COMPLETED',
} as const satisfies Record<string, PersonalizedTaskStatus>;

export const PERSONALIZED_TASKS_GENERATION_STATUSES = {
	PENDING: 'PENDING',
	IN_PROGRESS: 'IN_PROGRESS',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED',
} as const satisfies Record<string, PersonalizedTasksStatus>;
